import { Routes, Route, Navigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { onAuthStateChanged, User } from 'firebase/auth'
import { auth } from './lib/firebase'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import LettersPage from './pages/LettersPage'
import UsersPage from './pages/UsersPage'
import SettingsPage from './pages/SettingsPage'
import Layout from './components/Layout'

function App() {
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    // Check if Firebase config is available
    if (!import.meta.env.VITE_FIREBASE_API_KEY) {
      setError('Firebase yapılandırması eksik. Lütfen environment variables\'ları kontrol edin.')
      setLoading(false)
      return
    }

    const unsubscribe = onAuthStateChanged(
      auth,
      (currentUser) => {
        setUser(currentUser)
        setLoading(false)
      },
      (err) => {
        console.error('Auth state error:', err)
        setError('Kimlik doğrulama hatası. Lütfen sayfayı yenileyin.')
        setLoading(false)
      }
    )

    return () => unsubscribe()
  }, [])

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="bg-white rounded-lg shadow-lg p-6 max-w-md">
          <h1 className="text-xl font-bold text-red-600 mb-2">Hata</h1>
          <p className="text-gray-700">{error}</p>
        </div>
      </div>
    )
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (!user) {
    return <LoginPage />
  }

  return (
    <Layout user={user}>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/letters" element={<LettersPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}

export default App
